var exports = {
  "KE": "SelectionFormattingToolbar.module__toolbar___OFYtUn",
  "x6": "SelectionFormattingToolbar.module__button___OFYtUn",
  "rK": "SelectionFormattingToolbar.module__buttonActive___OFYtUn",
  "Kk": "SelectionFormattingToolbar.module__icon___OFYtUn",
};

module.exports = exports;
